"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaxReportMutation = void 0;
var tax_1 = require("../tax");
var react_query_1 = require("react-query");
function useTaxReportMutation(options) {
    return (0, react_query_1.useMutation)(tax_1.taxReport, options);
}
exports.useTaxReportMutation = useTaxReportMutation;
